import { render, staticRenderFns } from "./Model21.vue?vue&type=template&id=ad8d17ba&scoped=true&"
import script from "./Model21.vue?vue&type=script&lang=js&"
export * from "./Model21.vue?vue&type=script&lang=js&"
import style0 from "./Model21.vue?vue&type=style&index=0&id=ad8d17ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8d17ba",
  null
  
)

export default component.exports